import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

const i18n = defineMessages({
	rulePreviewErrorMessage: {
		id: 'automation-extensions.smart-button.rule-preview.error',
		defaultMessage: 'We are having trouble loading this information.',
		description: 'An error message on a hover state when we are unable to load the rule summary.',
	},
});

export const ErrorRulePreview = () => (
	<Box paddingBlock="space.050">
		<Inline space="space.150" alignBlock="center">
			<StatusWarningIcon color={token('color.icon.subtle')} label="" />
			<Text align="start" size="small">
				<FormattedMessage {...i18n.rulePreviewErrorMessage} />
			</Text>
		</Inline>
	</Box>
);
